import React, { useMemo } from 'react';
import { Form, Select, TreeSelect } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { sortByLocalCompare } from '../../helpers/helpers';

const getOptions = (array, divisionId) => (
  array
    .filter((item) => (
      item.active
      && item.divisionIds?.includes(divisionId)
    ))
    .map((item) => ({ label: item.name, value: item.id }))
);

function CustomExportFormFilters({
  divisionId,
  onFilterChange,
  selectedCustomers,
  selectedEquipment,
  selectedBuckets,
}) {
  const customers = useSelector((state) => state.customers.customers);
  const equipment = useSelector((state) => state.equipment.equipment);
  const buckets = useSelector((state) => state.buckets.buckets);

  const customerOptions = useMemo(() => (
    getOptions(Object.values(customers), divisionId)
  ), [customers, divisionId]);

  const equipmentOptions = useMemo(() => (
    getOptions(equipment, divisionId)
  ), [customers, divisionId]);

  const bucketOptions = useMemo(() => {
    const parent = {};
    buckets.forEach((bucket) => {
      const {
        bucketTemplateId,
        templateName,
        name,
        id,
      } = bucket;
      if (!(bucketTemplateId in parent)) {
        parent[bucketTemplateId] = {
          title: templateName,
          value: bucketTemplateId,
          selectable: false,
          children: [],
        };
      }
      parent[bucketTemplateId].children.push({
        title: name,
        value: id,
        selectable: true,
        children: [],
      });
    });
    const values = Object.values(parent);
    values.sort(sortByLocalCompare());
    return values;
  }, [buckets]);

  return (
    <>
      <Form.Item
        name="customers"
        label="Customers"
      >
        <Select
          onChange={onFilterChange('customers')}
          allowClear
          options={customerOptions}
          mode="multiple"
          placeholder="Customers"
          values={selectedCustomers}
          optionFilterProp="label"
          showSearch
        />
      </Form.Item>
      <Form.Item
        name="equipment"
        label="Equipment"
      >
        <Select
          onChange={onFilterChange('equipment')}
          allowClear
          options={equipmentOptions}
          mode="multiple"
          placeholder="Equipment"
          values={selectedEquipment}
          optionFilterProp="label"
          showSearch
        />
      </Form.Item>
      {
        buckets.length > 0 && (
          <Form.Item
            name="buckets"
            label="Buckets"
          >
            <TreeSelect
              onChange={onFilterChange('buckets')}
              allowClear
              treeData={bucketOptions}
              multiple
              treeNodeFilterProp="title"
              placeholder="Buckets"
              values={selectedBuckets}
            />
          </Form.Item>
        )
      }
    </>
  );
}

CustomExportFormFilters.propTypes = {
  divisionId: PropTypes.string.isRequired,
  onFilterChange: PropTypes.string.isRequired,
  selectedCustomers: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedEquipment: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedBuckets: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CustomExportFormFilters;
